import { Injectable, inject } from '@angular/core';
import { Guid } from '@web/utils';
import { MultimediaThumbnailVariant } from '../../shared/enums/multimedia-thumbnail-variant';
import { MultimediaBucket } from '../../shared/enums/multimedia-bucket';
import { PublicMultimediaApiService } from '../api/services/public-multimedia-api.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { UploadException } from '@web/shared/ui';
import { HttpErrorService } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class PublicMultimediaDataSourceService {
  private readonly httpError = inject(HttpErrorService);
  private readonly multimediaApi = inject(PublicMultimediaApiService);

  public shopFileThumbnailUrl(
    id: Guid,
    variant: MultimediaThumbnailVariant = MultimediaThumbnailVariant.Mini,
  ): string {
    return this.multimediaApi.fileThumbnailUrl({
      id,
      variant,
      bucket: MultimediaBucket.Shop,
    });
  }

  public shopFilePreviewUrl(id: Guid): string {
    return this.multimediaApi.filePreviewUrl({
      id,
      bucket: MultimediaBucket.Shop,
    });
  }

  public warehouseFileThumbnailUrl(
    id: Guid,
    variant: MultimediaThumbnailVariant = MultimediaThumbnailVariant.Mini,
  ): string {
    return this.multimediaApi.fileThumbnailUrl({
      id,
      variant,
      bucket: MultimediaBucket.Warehouse,
    });
  }

  public warehouseFilePreviewUrl(id: Guid): string {
    return this.multimediaApi.filePreviewUrl({
      id,
      bucket: MultimediaBucket.Warehouse,
    });
  }

  public shopUpload(file: File): Observable<Guid> {
    return this.multimediaApi
      .upload({
        file,
        bucket: MultimediaBucket.Shop,
      })
      .pipe(
        map((response) => response.id),
        catchError((response) =>
          throwError(
            () =>
              new UploadException(
                this.httpError.extract(response).multiLineMessages(),
              ),
          ),
        ),
      );
  }
}
